import type { ComponentType } from 'react';
import type { DiagramType } from '../../../core/tools/interfaces/ITool';

export interface CanvasProjectionPaneProps {
  readonly diagramId: string | undefined;
  readonly diagramType?: DiagramType;
}

export interface CanvasProjectionDefinition {
  readonly kind: string;
  readonly component: ComponentType<CanvasProjectionPaneProps>;
  readonly supportsDiagramType?: (diagramType: DiagramType | undefined) => boolean;
}

const canvasProjectionDefinitions = new Map<string, CanvasProjectionDefinition>();

export function registerCanvasProjectionDefinition(definition: CanvasProjectionDefinition): void {
  canvasProjectionDefinitions.set(definition.kind, definition);
}

export function getCanvasProjectionDefinition(
  kind: string,
): CanvasProjectionDefinition | null {
  return canvasProjectionDefinitions.get(kind) ?? null;
}
